export const createColStylesGeneratorForTheme = (theme) => (width, paddingRight = 10, paddingLeft = 10) => ({
    paddingLeft,
    paddingRight,
    [theme.breakpoints.up('lg')]: width === 'auto'
        ? { width, minWidth: 0 }
        : {
            width, minWidth: width,
        },
});
